import React from "react";
import "../../../../../css/pages/ca_pages/teams/teams_model/DashboardWelcomeBanner.css";

const DashboardWelcomeBanner = ({ summary = {}, onRefresh }) => {
    const hour = new Date().getHours();
    let greeting = "Good Evening";

    if (hour < 12) { greeting = "Good Morning";
    } else if (hour < 17) { greeting = "Good Afternoon"; }

    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "30px",
                }}
            >
                <div>
                    <h1 style={{ margin: 0, fontSize: "32px" }}>
                        Team Dashboard
                    </h1>

                    <p style={{ marginTop: "8px", color: "#64748b" }}>
                        Monitor your team's productivity and ongoing work.
                    </p>
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                    {onRefresh && (
                        <button
                            onClick={onRefresh}
                            style={{
                                padding: "12px 18px",
                                border: "1px solid #e2e8f0",
                                borderRadius: "10px",
                                background: "#fff",
                                cursor: "pointer",
                                fontWeight: 600,
                            }}
                        >
                            Refresh
                        </button>
                    )}

                    <button
                        style={{
                            background: "#2563eb",
                            color: "#fff",
                            border: "none",
                            borderRadius: "10px",
                            padding: "12px 22px",
                            cursor: "pointer",
                            fontWeight: 600,
                        }}
                    >
                        + Create Task
                    </button>
                </div>
            </div>

            <div className="dashboard-banner">
                <div className="banner-left">
                    <h1>{greeting} 👋</h1>

                    <p>Here's what's happening across your team today.</p>
                </div>

                <div className="banner-summary">
                    <div className="summary-item">
                        <span className="summary-value">
                            {summary.employees ?? 0}
                        </span>

                        <span className="summary-label">
                            Employees
                        </span>
                    </div>

                    <div className="summary-item">
                        <span
                            className="summary-value"
                            style={{ color: "#16a34a" }}
                        >
                            {summary.working ?? 0}
                        </span>

                        <span className="summary-label">
                            Working
                        </span>
                    </div>

                    <div className="summary-item">
                        <span
                            className="summary-value"
                            style={{ color: "#ea580c" }}
                        >
                            {summary.open_tasks ?? 0}
                        </span>

                        <span className="summary-label">
                            Open Tasks
                        </span>
                    </div>

                    <div className="summary-item">
                        <span
                            className="summary-value"
                            style={{ color: "#dc2626" }}
                        >
                            {summary.overdue_tasks ?? 0}
                        </span>

                        <span className="summary-label">
                            Overdue
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DashboardWelcomeBanner;
